var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"startCredentialsDiv"},[_c('sc-field-group',{ref:"scFieldGroup",attrs:{"fieldGroupName":_vm.fieldGroupName,"fieldGroup":_vm.fieldGroup,"specific-component":_vm.specificComponent}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1628ed42","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/credentials/ScCarrierCredentials.vue
// module id = null
// module chunks = 